<template>
  <div class="top">
    <h1 class="info-title black" style="padding-top: 60px;">
      Your last 6 months' <b>summary</b>
    </h1>
    <p class="section-subtitle">
      Here is a cashflow summary based on your income and spending from the <br>last 6 months
    </p>
    <div
      class="breakdown-table"
      :class="{ 'disabled': isDataMissing }"
    >
      <div
        v-if="isDataMissing"
        class="connect-another-subtitle missing-data-subtitle"
      >
        Unlock your last 6 months' summary by <b @click="handleConnectAccountsClick">connecting your current account</b>
      </div>
      <div class="breakdown-content">
        <div class="breakdown-row">
          <div class="col source">
            Average monthly <b>income</b>
          </div>
          <div class="col invest">
            £{{ numberToHumanReadable(monthlyAvgIncomeSpending.income) }}
          </div>
        </div>

        <div class="breakdown-row">
          <div class="col source">
            Average monthly <b>spending</b>
          </div>
          <div class="col invest">
            £{{ numberToHumanReadable(monthlyAvgIncomeSpending.spending) }}
          </div>
        </div>

        <div class="breakdown-row breakdown-total-row">
          <div class="col source">
            Your avg monthly <b>net balance</b>
          </div>
          <div class="col invest" :class="{ 'green-text': monthlyAvgDisposableIncome.total > 0 }">
            £{{ numberToHumanReadable(monthlyAvgDisposableIncome.total) }}
          </div>
        </div>
      </div>
      <div
        v-if="!isDataMissing"
        class="connect-another-subtitle"
      >
        Numbers look off? Get an accurate analysis by <b @click="handleConnectAccountsClick">connecting another account</b>
      </div>
    </div>
  </div>
</template>

<script setup>
import { numberToHumanReadable } from '../../../../utils/miscUtils';

const props = defineProps({
  monthlyAvgIncomeSpending: {
    type: Object,
    required: true,
  },
  monthlyAvgDisposableIncome: {
    type: Object,
    required: true,
  },
  isDataMissing: {
    type: Boolean,
    required: true,
  },
});

const emit = defineEmits(['connectAccountsClick']);

const handleConnectAccountsClick = () => {
  emit('connectAccountsClick');
};
</script>

<style lang="scss" scoped>
@import '../../../../scss/riseup-vars';

.top {
  background-color: #FCF7ED;
  padding-bottom: 45px;
  padding-top: 45px;
}

.info-title {
  font-size: 36px;
  padding-top: 40px;
  padding-right: 25px;
  margin-bottom: 20px;
  text-align: left;
  width: 80%;
  margin-left: auto;
  margin-right: auto;
  font-weight: 100 !important;
  line-height: 1;
}

.black {
  color: #202125;
}

.info-title b {
  font-weight: 700;
}

.section-subtitle {
  font-size: 17px;
  margin-top: 25px;
  margin-bottom: 40px;
  text-align: left;
  width: 80%;
  margin-left: auto;
  margin-right: auto;
  line-height: 1.5;
  color: #202125;
}

.connect-another-subtitle {
  font-size: 14px;
  margin-bottom: 10px;
  margin-top: 20px;
  background: #FFE7C3;
  padding: 20px;
  border-radius: 16px;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  font-weight: 100 !important;
}

.missing-data-subtitle {
  background-color: #FFDC73;
  text-align: center;
}

.connect-another-subtitle b {
  font-weight: 700;
  text-decoration: underline;
  cursor: pointer;
}

.breakdown-table {
  width: 90%;
  background-color: white;
  box-shadow: 0px 16px 46.4px 0px #00000026;
  border-radius: 25px;
  padding: 25px;
  margin-top: 20px;
  z-index: 2;
  margin: 0 auto;
  position: relative;
  padding-top: 30px;
}

.breakdown-table.disabled {
  background-color: #F1F5FA !important;
  box-shadow: 0px 16px 46.4px 0px #00000010 !important;
}

.breakdown-content {
  width: 100%;
}

.breakdown-row {
  display: flex;
  padding: 15px 5px;
  border-bottom: 1px solid rgba(32, 84, 65, 0.2);

  &:last-child {
    border-bottom: none;
  }
}

.col {
  color: #202125;
  .disabled & {
    color: #B0B0B0 !important;
  }

  &.source {
    flex: 4;
    text-align: left;
  }

  &.invest {
    flex: 1;
    text-align: right;
    font-weight: 700;
  }
}

.breakdown-total-row {
  font-weight: 100;
}

.breakdown-total-row b {
  font-weight: 700;
}

.breakdown-total-row .col.invest {
  &.green-text {
    color: #13C636;
  }
}
</style>
